<div class="container-fluid contact-us-section text-white" id="CONTACT_US">
    <div class="row">

      <div class="section-heading">
        <u>&nbsp;&nbsp;Contact</u>&nbsp;<u>Us&nbsp;&nbsp;</u>
      </div>

      <div class="col-lg-4 col-md-5 col-sm-12">

        <div class="d-flex my-4 ms-5">
          <div class="round">
            <mat-icon class="text-center align-items-center"> email</mat-icon>
          </div>
          <div class="d-flex flex-column ps-2">
            <span>Email</span>
            <span>{{ school?.cnctEmail || 'N/A' }}</span>
          </div>
        </div>

        <div class="d-flex my-5 ms-5 align-items-center">
          <div class="round">
            <mat-icon class="text-center align-items-center"> phone</mat-icon>
          </div>
          <div class="d-flex flex-column ps-2">
            <span>Phone</span>
            <span>{{ school?.cnctMobNum || 'N/A' }}</span>
          </div>
        </div>

        <div class="d-flex my-5 ms-5 align-items-center">
          <div class="round">
            <mat-icon class="text-center align-items-center"> place</mat-icon>
          </div>
          <div class="d-flex flex-column ps-2">
            <span>Address</span>
            <span>{{school?.schAddLine || 'N/A'}}</span>
          </div>
        </div>

      </div>

      <!-- FORM -->
      <form [formGroup]="contactForm" (ngSubmit)="submit()" class="col-lg-5 col-md-5 col-sm-12">
        <div class="row">
          <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2 mt-2">
            <label>Name <span class="text-danger">*</span></label>
            <input
              type="text"
              class="white-border"
              placeholder="Enter your name"
              formControlName="visitorName">

            <small class="text-danger" *ngIf="f.visitorName.touched && f.visitorName.invalid">
              Name is required (min 3 chars)
            </small>

          </div>

          <div class="mt-2 d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2">
            <label>Email <span class="text-danger">*</span></label>
            <input
              type="email"
              class="white-border"
              placeholder="Enter your email"
              formControlName="emailId">

            <small class="text-danger" *ngIf="f.emailId.touched && f.emailId.invalid">
              Enter a valid email
            </small>

          </div>
        </div>

        <div class="row mt-2">
          <div class="d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2 mt-2">
            <label>Phone <span class="text-danger">*</span></label>
            <input
              type="text"
              maxlength="10"
              class="white-border"
              placeholder="10 digit phone number"
              formControlName="phoneNo"
              (keypress)="allowOnlyNumbers($event)">

            <small class="text-danger" *ngIf="f.phoneNo.touched && f.phoneNo.invalid">
              Phone must be exactly 10 digits
            </small>
          </div>

          <div class="mt-2 d-flex flex-column col-lg-6 col-md-6 col-sm-12 px-2">
            <label>Town <span class="text-danger">*</span></label>
            <input
              type="text"
              class="white-border"
              placeholder="Enter your town"
              formControlName="town">

            <small class="text-danger" *ngIf="f.town.touched && f.town.invalid">
              Town is required
            </small>
          </div>
        </div>

        <div class="row mt-2">
          <div class="d-flex flex-column col-lg-12 col-md-6 col-sm-12 px-2">
            <label>Description <span class="text-danger">*</span></label>
            <textarea
              rows="4"
              class="white-border1"
              placeholder="Write your message..."
              formControlName="remarks"></textarea>

            <small class="text-danger" *ngIf="f.remarks.touched && f.remarks.invalid">
              Minimum 10 characters required
            </small>
          </div>
        </div>

        <div class="mt-4 text-center">
          <button mat-button type="submit" class="contact-submit-btn"
            [disabled]="contactForm.invalid || loading">

            <mat-spinner
              *ngIf="loading"
              diameter="22"
              strokeWidth="3">
            </mat-spinner>

            <span *ngIf="!loading">Send Message</span>
          </button>
        </div>

      </form>

      <!-- GOOGLE MAP -->
      <div class="col-lg-3 col-md-2 col-sm-12 my-3">
        <div class="map-container">
          <iframe *ngIf="mapUrl"
            [src]="mapUrl"
            width="100%"
            height="280"
            style="border:0; border-radius: 8px;"
            allowfullscreen
            loading="lazy">
          </iframe>
        </div>
      </div>

    </div>
  </div>